type HttpErrorShape = {
  response?: {
    status?: number;
    data?: { message?: string | string[] };
  };
};

const readBackendMessage = (error: unknown): string => {
  const raw = (error as HttpErrorShape).response?.data?.message;
  if (Array.isArray(raw)) return raw.join(", ");
  return raw ?? "";
};

export const resolveInitiateCallErrorMessage = (
  error: unknown,
): { message: string; severity: "warning" | "error" } => {
  const status = (error as HttpErrorShape).response?.status;
  const backendMessage = readBackendMessage(error);


  if (status === 409) {
    if (/receiver is (busy|ringing)/i.test(backendMessage)) {
      return {
        message: "The contact is already on an active call.",
        severity: "warning",
      };
    }

    if (/caller is (busy|ringing)/i.test(backendMessage)) {
      return {
        message: "You already have an active call.",
        severity: "warning",
      };
    }

    if (/receiver is offline/i.test(backendMessage)) {
      return {
        message: "The contact is not available at the moment.",
        severity: "warning",
      };
    }

    if (/already being called/i.test(backendMessage)) {
      return {
        message: "The contact is already receiving another call.",
        severity: "warning",
      };
    }

    return {
      message: "Cannot start the call at this time.",
      severity: "warning",
    };
  }

  if (status === 403) {
    return {
      message: "You do not have permission to make this call.",
      severity: "error",
    };
  }

  return {
    message: "Cannot start the call. Try again.",
    severity: "error",
  };
};
